<template>
    <card-seplag titulo="Extrato de Férias">
        <div class="p-col-12 div-mae">
            <div class="barra-status" >
                <span class="customer-badge status-EM_HAVER" style="font-size:10px">Em haver</span> &nbsp;
                <span class="customer-badge status-GOZADO_PARCIALMENTE" style="font-size:10px">Gozado Parcialmente</span> &nbsp;
                <span class="customer-badge status-ENCERRADO" style="font-size:10px">Encerrado</span>
            </div>

            <div class="botao-imprimir">
                <Button label="Imprimir" icon="pi pi-print" iconPos="right" @click="imprimirFerias" class="btn-imprimir"/>
            </div>
        </div>
        <br><br>
        <div class="p-col-12">
        <DataTable  :value="ferias" rowGroupMode="subheader" groupRowsBy="chave" sortMode="single" :paginator="true" :rows="6" 
        :lazy="true" :totalRecords.sync="totalLinhas" :loading="loadingPaginacao" @page="atualizaPaginacao($event)">
            <template #groupheader="slotProps">
                <div class="p-grid " style="margin-top:2px">
                    <div class="p-col-9 p-md-10" :class="'customer-badge status-' + slotProps.data.condicaoPeriodoAquisitivo"><br>Período aquisitivo: {{slotProps.data.dtIniPeriodoAquisitivo}} à {{slotProps.data.dtFimPeriodoAquisitivo}}
                    </div>
                    <div align="center"  class="p-col-3 p-md-2" :class="'customer-badge status-' + slotProps.data.condicaoPeriodoAquisitivo"><span style="font-size:18px">{{slotProps.data.diasDireito}}</span> <br>dias de Direito
                    </div>
                </div>
            </template>            
            <Column>
                <template #body="slotProps">
                    <div v-for="(listaFerias, index) in slotProps.data.listaFerias" :key="`${index}`">
                        <span>{{listaFerias.dataInicio}} à {{listaFerias.dataFim}} (<b>{{listaFerias.saldoFerias}}</b> dias)</span>
                    </div>              
                </template>
            </Column>
        </DataTable>
        </div>
        <CardExibirPDF v-if="pdfElement" v-model="exibirPDF" :nomeDocumento='nomeDocumentoPDF' :tituloTela="'Extrato de Férias'" :position="'top'" :tamanhoTela="'55.em'"  :alturaTela="'55.em'" :pdfElement="pdfElement" />

	</card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import { baseApiUrl } from '@/config/global'
import CardExibirPDF from '@/template/CardExibirPDF.vue'


export default {
    name: 'extratoFeriasServidor',
    components: { CardSeplag, CardExibirPDF},    
    data(){
        return{
            apiUrlRecurso: 'extratoferias',
            totalElements: 0,
            ferias : [{
                chave: null,
                condicaoPeriodoAquisitivo: null,
                dtIniPeriodoAquisitivo: null,
                dtFimPeriodoAquisitivo: null,
                diasDireito: null,
                listaFerias: [{dataInicio: null, dataFim: null, saldoFerias:null}]
            }],
            matricula: null,
            vinculo: null,

            totalLinhas: 0,
            tamanhoPorpagina: 6,
            loadingPaginacao: true,
            pdfElement: null,
            exibirPDF:false             
            
        }
    },
    methods:{
        imprimirFerias(){
            let dadosPDF = {
                "matricula": this.$store.getters.getMatricula,
                "vinculo": this.$store.getters.getVinculo,
                "tipoAfastamento": "FERIAS",
            } 
            this.$http.post(`${baseApiUrl}/relatorios/gerarextrato`,JSON.stringify(dadosPDF)).then(res => {
                this.pdfElement = res.data.dadosRelatorioBase64
                this.nomeDocumentoPDF = res.data.nomeArquivo
                this.exibirPDF = true
            })
        },
        carregarDados(){
            this.matricula  =  this.$store.getters.getMatricula
            this.vinculo =  this.$store.getters.getVinculo
            this.$http.get(`${baseApiUrl}/${this.apiUrlRecurso}/${this.matricula}/${this.vinculo}?size=${this.tamanhoPorpagina}&page=0`).then(res => {
                this.ferias = res.data.content.map((elemento) => {
                    let listaDiasUsado = []
                    if(elemento.listaFerias.length >0 ){
                        listaDiasUsado = elemento.listaFerias.sort(function (a, b) {
                            let pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
                            let data1 = new Date(
                            a.dataInicio.replace(pattern, "$3-$2-$1")
                            );
                            let data2 = new Date(
                            b.dataInicio.replace(pattern, "$3-$2-$1")
                            );
                            if (data1 > data2) {
                            return -1;
                            } else {
                            return 1;
                            }
                        });
                    }
                    return {...elemento, listaFerias: listaDiasUsado }
                })
                this.totalLinhas = res.data.totalElements
                this.loadingPaginacao = false
            })
        },        
        atualizaPaginacao(event) {
            this.loadingPaginacao = true;            
            this.$http.get(`${baseApiUrl}/${this.apiUrlRecurso}/${this.matricula}/${this.vinculo}?size=${event.originalEvent.rows}&page=${event.originalEvent.page}`).then(res => {
                this.ferias = res.data.content
                this.loadingPaginacao = false
            })
        }
    },
    mounted(){        
        this.carregarDados()
    }
}
</script>
<style scoped>

    .barra-status{
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }

    .btn-imprimir{
        width: 100px;
    }

    @media screen and (max-width:603px) {
        .botao-imprimir{
            width: 25% !important;;
        }    
    }

     @media screen and (max-width:455px) {
        .botao-imprimir{
            width: 100% !important;;
        }    
        .div-mae{
            flex-direction: column  !important;;
        }

        .btn-imprimir{
            width: 100% !important;
        }
    }

    .botao-imprimir{
        /* display: flex;
        text-align: center;
        justify-content: center;
        padding: 0px;

        display: flex;
        align-items: center;
        margin-bottom: 10px; */
        width: 16.6667%;
        
         text-align: center;
    }

    .dashboard > div {
        padding: 1em;
    }
    .dashboard .dashboard-grid {
        margin-left: 0;
        margin-right: 0;
        margin-top: 0;
        padding: 0;
    }
    .dashboard .card {
        height: 100%;
        margin-bottom: 0;
    }
    .dashboard .summary-box {
        position: relative;
    }
    .dashboard .summary-box .card {
        min-height: 100px;
    }
    .dashboard .summary-box .summary-box-title {
        font-size: 2em;
        margin: 0;
        color: #ffffff;
    }
    .dashboard .summary-box p {
        margin: 0.25em 0;
        color: #ffffff;
    }
    .dashboard .summary-box .summary-box-icon {
        position: absolute;
        font-size: 5em;
        right: 24px;
        top: 32px;
    }
    .dashboard .summary-box .summary-box-graph {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    .dashboard .summary-box.summary-box-azul .card {
        border-top: 4px solid #0097a7;
        background-color: #00bcd4;
    }
    .dashboard .summary-box.summary-box-azul .ico {
        color: #0097a7;
    }
    .dashboard .summary-box.summary-box-rosa .card {
        border-top: 4px solid #ad1457;
        background-color: #e91e63;
    }
    .dashboard .summary-box.summary-box-rosa .ico {
        color: #ad1457;
    }
    .dashboard .summary-box.summary-box-amarelo .card {
        border-top: 4px solid #f47b08;
        background-color: #ffb300;
    }
    .dashboard .summary-box.summary-box-amarelo .ico {
        color: #f47b08;
    }
    .dashboard .summary-box.summary-box-cinza .card {
        border-top: 4px solid #455a64;
        background-color: #607d8b;
    }
    .dashboard .summary-box.summary-box-cinza .ico {
        color: #455a64;
    }

    .div-mae{
        display: flex;
        justify-content: space-between;
    }

    /* STATUS DE VALIDAÇÃO DA CHEFIA*/
    .customer-badge {
        border-radius: 2px;
        padding: .25em .5em;
        text-transform: uppercase;
        font-weight: 700;
        font-size: 12px;
        letter-spacing: .3px;
    }
        .status-EM_HAVER {
            background-color: #C8E6C9;
            color: #256029;

        }

        .status-ENCERRADO {
            background-color: #FFCDD2;
            color: #C63737;
        }

        .status-negotiation {
            background-color: #FEEDAF;
            color: #8A5340;
        }

        .status-GOZADO_PARCIALMENTE {
            background-color: #B3E5FC;
            color: #23547B;
        }

        .status-renewal {
            background-color: #ECCFFF;
            color: #694382;
        }

        .status-proposal {
            background-color: #FFD8B2;
            color: #805B36;
        }
    

        /* status */
        .status-Usufruido {
            font-weight: bold;
            color: #23547B;
        }
        .status-Agendado {
            font-weight: bold;
            color: #256029;
        }
        .status-Aguardando {
            font-weight: bold;
            color: yellowgreen;
        }
</style>